import React from "react";
import "../style.css";

export const StepperControl = ({ handleClick, currentStep, steps }) => {
  return (
    <div className="flex justify-between">
      <button
        onClick={() => handleClick()}
        className={`cursor-pointer text-lg rounded-xl bg-darkbg font-semibold text-zinc-600 transition duration-200 ease-in-out hover:scale-110 hover:text-LightOrange  ${
          currentStep === steps.length ? "hidden" : "block"
        }
            `}
      >
        Back
      </button>
      <button
        onClick={() => handleClick("next")}
        className={`cursor-pointer rounded-xl text-lg bg-darkbg font-semibold text-OrangyRed transition duration-200 ease-in-out hover:scale-110 hover:text-LightOrange ${
          currentStep === steps.length ? "hidden" : "block"
        }`}
      >
        {currentStep === steps.length - 1 ? "" : "Next"}
      </button>
    </div>
  );
};
